/**
 * Import plugin configurations.
 */
import Vue from "vue";
import moment from "moment";
import "@/config/axios";
import "@/config/axios-cms";
import "@/config/axios-account-api";
import "@/config/axios-memod";
import * as filters from "@/utils/filters";
import "@/config/vee-validate";

// Only report errors on production
if (process.env.NODE_ENV !== "development") {
    require("@/config/sentry");
}

// Register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

window.moment = moment;
window.facebookAppId = process.env.VUE_APP_FACEBOOK_APP_ID;
